const IMG_STATIC_BASE_URL = 'https://imgstatic.phonepe.com/images';

export const LOGIN_SDK_CONFIG = {
	clientId: process.env.PHONEPE_LOGIN_CLIENT_ID as string,
	redirectUri: process.env.PHONEPE_LOGIN_REDIRECT_URI as string,
	scope: 'b2bpg',
	responseType: 'code',
	appId: process.env.PHONEPE_LOGIN_APP_ID as string,
	authBaseURL: process.env.PHONEPE_LOGIN_AUTH_URL as string,
	accountServiceBaseURL: process.env
		.PHONEPE_LOGIN_ACCOUNT_SERVICE_URL as string,
};

export const Global = Object.freeze({
	USER_ORG: 'PHONEPEPG',

	MERCHANT_LOGO_BASE_URL: `${IMG_STATIC_BASE_URL}/merchants/200/200/`,
	MERCHANT_LOGO_FALLBACK: `${IMG_STATIC_BASE_URL}/merchants/200/200/M2306160483220675579140.png`,
	NO_CARDS_FOUND: `${IMG_STATIC_BASE_URL}/mercury-ui/icons/531/532/noCardsFound.png`,
	AUTH_TOKEN: 'AUTH_TOKEN',
	USER_ID: 'USER_ID',
	FINGERPRINT_COOKIE: '_MCP_V1',
	BASE_HEADERS: {
		'x-source-platform': 'BROWSER',
		'x-app-id': LOGIN_SDK_CONFIG.appId,
		'Content-Type': 'application/json',
	},
	FINGERPRINT_HEADER: 'x-device-fingerprint',
});
